import React from 'react'
import AboutPlace from '../Placedetail/AboutPlace'
import PlaceFeature from '../Placedetail/PlaceFeature'
import PlaceLocation from '../Placedetail/PlaceLocation'
import PlaceReserve from '../Placedetail/PlaceReserve'
import PlaceRules from '../Placedetail/PlaceRules'
import PlaceSlider from '../Placedetail/PlaceSlider'
import Placetitle from '../Placedetail/Placetitle'

export const EditResidenceBody = ({inforesidencedetail}) => {
  return (
    <div className='EditResidenceBody'>

        <div className="PlaceDetail__container">
           <div>
           <Placetitle inforesidencedetail={inforesidencedetail}/>
           <hr/>
           <PlaceSlider  inforesidencedetail={inforesidencedetail} />
           <AboutPlace  inforesidencedetail={inforesidencedetail} />
           <hr />
           <PlaceLocation inforesidencedetail={inforesidencedetail}/>
           <hr />
           {inforesidencedetail.instant_reserve === 1 && <PlaceReserve />}
           <hr />
           <PlaceFeature inforesidencedetail={inforesidencedetail} />
           <hr />
           <PlaceRules inforesidencedetail={inforesidencedetail}/>
          </div>
         
        </div>
    </div>
  )
}
